/**
 * Registers an iframe plugin directive with the given module.
 * This directive is used to create an iframe element with specific attributes and behaviors.
 * 
 * @param {object} module - The AngularJS module to which the directive will be registered.
 */
export default function registerIframePluginDirective(module) {
    module.directive('iframePlugin', function() {
        return {
            /**
             * Restricts the directive to be used as an element only.
             */
            restrict: 'E',
            /**
             * Determines whether the directive replaces the element that it's applied to.
             * In this case, it does not replace the element.
             */
            replace: false,
            /**
             * Defines the scope for the directive.
             * - uuid: A string attribute that is one-way bound.
             * - src: A string attribute that is one-way bound.
             * - signal: A string attribute that is one-way bound.
             * - style: A two-way bound attribute.
             */
            scope: {
                uuid: '@',
                src: '@',
                signal: '@',
                style: '=',
            },
            /**
             * Specifies the controller to be associated with the directive.
             */
            controller: 'IframePluginController',
            /**
             * Specifies the URL of the template to be used by the directive.
             */
            templateUrl: '/scripts/ib/components/core/IframePluginView.html'
        };
    });
}